module.exports = __webpack_public_path__ + "assets/img/yonghu.f62cc3b8.png";